// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.editor[data-v-b27762de] {\n  font-family: monospace;\n  padding: 0.5em;\n  background: #fff;\n  color: black;\n}\n", ""]);
// Exports
module.exports = exports;
